import React from 'react'
import Helmet from 'react-helmet'
import { createPageTitle } from 'utils/createPageTitle'
import { connect } from 'react-redux'
import { Page } from 'framework7-react'
import { HOME_ROUTE } from 'routes/consts'
import { changePassword } from 'store/actions/auth'
import { isValidPassword } from 'utils/validations'
import {
  Content,
  PrimaryInput,
  PrimaryButton,
  Navbar,
  Form,
  Header,
  Footer,
} from 'components'
import './ChangePassword.scss'

const mustBeEqualPassword = 'As senhas devem ser iguais.'
const invalidPassword = 'A senha deve conter mais de 6 caracteres.'

const passwordError = (newPassword, confirmPassword) => {
  if (confirmPassword && newPassword !== confirmPassword) return mustBeEqualPassword
  if (!isValidPassword(newPassword)) return invalidPassword
  return null
}

const canSubmit = (newPassword, confirmPassword) =>
  isValidPassword(newPassword) && newPassword === confirmPassword

class ChangePassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      newPassword: '',
      confirmChangePassword: '',
      error: null,
    }
  }

  handleChangePasswordChange(value) {
    this.setState(({ confirmChangePassword }) => ({
      newPassword: value,
      error: passwordError(value, confirmChangePassword),
    }))
  }

  handleConfirmChangePassword(value) {
    this.setState(({ newPassword }) => ({
      confirmChangePassword: value,
      error: passwordError(newPassword, value),
    }))
  }

  handleSubmit() {
    if (canSubmit(this.state.newPassword, this.state.confirmChangePassword)) {
      this.props.changePassword(this.state.newPassword).then(() => {
        this.$f7router.navigate({ name: HOME_ROUTE })
      })
    }
  }

  render() {
    const pageTitle = createPageTitle('nova senha')
    const { error, newPassword, confirmChangePassword } = this.state

    return (
      <Page className="welcome-layout change-password-page">
        <Helmet title={pageTitle} />
        <Navbar router={this.$f7router} backButton center={<div>Trocar senha</div>} />
        <Content className="change-password-page__content">
          <Header
            title="Digite sua nova senha"
            content="Precisamos que você crie uma nova senha para ter acesso."
          />
          <Form>
            <PrimaryInput
              placeholder="Nova senha"
              value={newPassword}
              onChange={e => this.handleChangePasswordChange(e.target.value)}
              type="password"
              isPassword
            />
            <PrimaryInput
              placeholder="Confirmação da nova senha"
              value={confirmChangePassword}
              className={error ? 'input-primary--has-error' : ''}
              onChange={e => this.handleConfirmChangePassword(e.target.value)}
              type="password"
              isPassword
            />
            {error && (
              <div className="change-password-page__content__error">
                <p>{error}</p>
              </div>
            )}
          </Form>
        </Content>
        <Footer>
          <PrimaryButton
            onClick={() => this.handleSubmit()}
            disabled={!canSubmit(newPassword, confirmChangePassword)}
          >
            Redefinir senha
          </PrimaryButton>
        </Footer>
      </Page>
    )
  }
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  changePassword: data => dispatch(changePassword(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
